import { TApplicationState } from '../../types/redux';

export const getBuilderChatContact = (state: TApplicationState) => state.builderChat.chatContact;
